<template>
  <div class="questions">
    <el-col :span="6">
      <strong>Полный список тестовых заданий</strong>
    </el-col>
    <el-col :span="4" class="pull-right">
      <el-button v-on:click="addQuestion" icon="plus" class="pull-right"> Добавить задание </el-button>
    </el-col>

    <div class="line">
    </div>
    <el-table
      :data="data"
      border
      style="width: 100%;">
      <el-table-column
        prop="uid"
        label="Идентификатор"
        width="300px">
      </el-table-column>
      <el-table-column
        prop="text"
        label="Текст">
      </el-table-column>
      <el-table-column
        prop="cost"
        label="Вес"
        width="80px">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  export default {
    name: 'questions',
    data() {
      return {
        prefix: config.API_PREFIX,
        data: [],
        isModalActive: false,
        // Create or edit
        isNew: true,
      }
    },
    methods: {
      fetchData() {
          let self = this;
          this.$gf.getOptions().then(options => {
            options.params = {
            };
            self.$http.get(`${self.prefix}questions`, options)
              .then(response => {
                self.data = response.data;
              })
              .catch(data => self.$gf.checkError(data))
          }).catch(err => this.$gf.catchOptions());
      },
      addQuestion() {
        this.isModalActive = true;
      },

      editQuestion(question) {
        this.isNew = false;
        this.newDeveloper = JSON.parse(JSON.stringify(question));
        this.isModalActive = true;
      },

      deletedToast() {
        this.$toast.open({
            message: `The question was deleted successfully`,
            type: 'is-success'
        })
      },

      deleteQuestion(question) {
        let self = this;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          self.$http.delete(`${self.prefix}questions/` + question.uid, options)
            .then(data => {
            self.deletedToast();
            self.fetchData();
          }).catch(data => self.$gf.checkError(data))
        }).catch(err => this.$gf.catchOptions());
      },

      confirmDelete(question) {
            this.$dialog.confirm({
                title: 'Deleting question',
                message: 'Are you sure you want to <strong>delete</strong> the question? This action cannot be undone.',
                confirmText: 'Delete question',
                type: 'is-danger',
                animation: null,
                hasIcon: false,
                onConfirm: () => this.deleteQuestion(question)
            })
      }
    },
    created() {
      this.fetchData();
    }
  }
</script>

<style scoped>
  .modal-content {
    width: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/operational/questions.vue